import React from 'react';

/**
 * Component to display notification-related banners with consistent styling
 * 
 * @param {Object} props - Component props
 * @param {string} props.message - The notification message to display
 * @param {string} [props.actionText] - Optional text for the action button 
 * @param {Function} [props.onAction] - Optional callback for when action button is clicked
 * @param {string} [props.type] - Banner type: 'info' (default), 'warning', 'error'
 */
const NotificationBanner = ({ 
  message, 
  actionText, 
  onAction, 
  type = 'info'
}) => {
  // Determine background and text colors based on type
  let bgColor = 'bg-blue-50';
  let textColor = 'text-blue-800';
  let borderColor = 'border-blue-200';
  let buttonClasses = 'bg-blue-700 text-white hover:bg-blue-800';
  
  if (type === 'warning') {
    bgColor = 'bg-amber-50';
    textColor = 'text-amber-800';
    borderColor = 'border-amber-200';
    buttonClasses = 'bg-amber-600 text-white hover:bg-amber-700';
  } else if (type === 'error') {
    bgColor = 'bg-red-50';
    textColor = 'text-red-800';
    borderColor = 'border-red-200';
    buttonClasses = 'bg-red-600 text-white hover:bg-red-700';
  }

  return (
    <div className={`flex justify-between items-center px-4 py-2 ${bgColor} border-b ${borderColor}`}>
      <p className={`text-sm ${textColor}`}>{message}</p>
      
      {actionText && onAction && (
        <button
          className={`px-3 py-1 rounded text-sm font-medium ${buttonClasses} transition-colors ml-4`}
          onClick={onAction}
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default NotificationBanner;